import React from 'react';
import './styles.css';

class TableWithChild extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      headerBody,
      childBody,
      footBody,
      tableClass,
      headerBodyClassName,
      childBodyClassName,
      footBodyClassName,
    } = this.props;
    return (
      <table
        className={`table mk-table-summary mk-table-fixed-hf report-table ${tableClass}`}
      >
        <thead>
          <tr>
            {headerBody.map((val, pidx) => {
              return (
                <th className={headerBodyClassName[pidx]} key={pidx}>
                  {val}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {childBody.map((val, idx) => {
            const valObj = Object.values(val.data);
            return (
              <tr key={idx}>
                {valObj.map((value, pidx) => {
                  return (
                    <td
                      key={pidx}
                      className={`${childBodyClassName[pidx]} ${
                        !val.isParent ? 'child' : ''
                      } ${val.isParent ? 'parent' : ''}`}
                    >
                      {value}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="divider text-total">
            {Object.values(footBody).map((value, pidx) => {
              return (
                <td key={pidx} className={footBodyClassName[pidx]}>
                  <b>{value}</b>
                </td>
              );
            })}
          </tr>
        </tfoot>
      </table>
    );
  }
}

export default TableWithChild;
